/**
 * Api PAS
 * Все методы Api PAS.
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {
    HttpClient,
    HttpContext,
    HttpEvent,
    HttpHeaders,
    HttpParameterCodec,
    HttpParams,
    HttpResponse
} from '@angular/common/http';
import {CustomHttpParameterCodec} from '../encoder';
import {Observable} from 'rxjs';


// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS} from '../variables';
import {Configuration} from '../configuration';


export interface ApiAnalyticReportCriterionFacilityGetRequestParams {
    organizationId?: number;
    periodId?: number;
    year?: number;
    quarter?: number;
    organizationGroupIds?: Array<number>;
    criterionId?: number;
}
export interface ApiAnalyticReportOrganizationsGetRequestParams {
    periodId?: number;
    year?: number;
    quarter?: number;
    organizationGroupIds?: Array<number>;
    criterionId?: number;
}

export interface ApiAnalyticReportCriterionFileGetRequestParams {
    periodId?: number;
    year?: number;
    quarter?: number;
    organizationGroupIds?: Array<number>;
    criterionId?: number;
}

export interface ApiAnalyticReportCriterionGetRequestParams {
    periodId?: number;
    year?: number;
    quarter?: number;
    organizationGroupIds?: Array<number>;
    criterionId?: number;
}

export interface ApiAnalyticReportFileGetRequestParams {
    organizationId?: number;
    periodId?: number;
    year?: number;
    quarter?: number;
    organizationGroupIds?: Array<number>;
    criterionId?: number;
}

export interface ApiAnalyticReportGeneralFileGetRequestParams {
    periodId?: number;
    year?: number;
    quarter?: number;
    organizationGroupIds?: Array<number>;
    criterionId?: number;
}

export interface ApiAnalyticReportGeneralGetRequestParams {
    periodId?: number;
    year?: number;
    quarter?: number;
    organizationGroupIds?: Array<number>;
    criterionId?: number;
}

export interface ApiReportAnalyticPeriodsParams {
    OrganizationGroupIds?: Array<number>;
    OrganizationIds?: Array<number>;
    OrgStatusIds?: Array<number>;
}

export interface Period {
    year: number|null, quarter: number | null
}
export interface ApiReportAnalyticRatingParams {
    OrganizationGroupIds?: Array<number>;
    OrganizationIds?: Array<number>;
    OrgStatusIds?: Array<number>;
    Periods?: Array<Period>;
    SearchString?: string;
}


@Injectable({
    providedIn: 'root'
})
export class AnalyticService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string | string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                    throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAnalyticReportCriterionFacilityGet(requestParameters: ApiAnalyticReportCriterionFacilityGetRequestParams, observe?: 'body', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any>;
    public apiAnalyticReportCriterionFacilityGet(requestParameters: ApiAnalyticReportCriterionFacilityGetRequestParams, observe?: 'response', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpResponse<any>>;
    public apiAnalyticReportCriterionFacilityGet(requestParameters: ApiAnalyticReportCriterionFacilityGetRequestParams, observe?: 'events', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpEvent<any>>;
    public apiAnalyticReportCriterionFacilityGet(requestParameters: ApiAnalyticReportCriterionFacilityGetRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any> {
        const organizationId = requestParameters.organizationId;
        const periodId = requestParameters.periodId;
        const year = requestParameters.year;
        const quarter = requestParameters.quarter;
        const organizationGroupIds = requestParameters.organizationGroupIds;
        const criterionId = requestParameters.criterionId;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (organizationId !== undefined && organizationId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>organizationId, 'OrganizationId');
        }
        if (periodId !== undefined && periodId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>periodId, 'PeriodId');
        }
        if (year !== undefined && year !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>year, 'Year');
        }
        if (quarter !== undefined && quarter !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>quarter, 'Quarter');
        }
        if (organizationGroupIds) {
            organizationGroupIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrganizationGroupIds');
            })
        }
        if (criterionId !== undefined && criterionId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>criterionId, 'CriterionId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/analytic/report/criterion/facility`;
        return this.httpClient.request<any>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAnalyticReportCriterionFileGet(requestParameters: ApiAnalyticReportCriterionFileGetRequestParams, observe?: 'body', reportProgress?: boolean, options?: {
        httpHeaderAccept?: string,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any>;
    public apiAnalyticReportCriterionFileGet(requestParameters: ApiAnalyticReportCriterionFileGetRequestParams, observe?: 'response', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpResponse<any>>;
    public apiAnalyticReportCriterionFileGet(requestParameters: ApiAnalyticReportCriterionFileGetRequestParams, observe?: 'events', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpEvent<any>>;
    public apiAnalyticReportCriterionFileGet(requestParameters: ApiAnalyticReportCriterionFileGetRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any> {
        const periodId = requestParameters.periodId;
        const year = requestParameters.year;
        const quarter = requestParameters.quarter;
        const organizationGroupIds = requestParameters.organizationGroupIds;
        const criterionId = requestParameters.criterionId;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (periodId !== undefined && periodId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>periodId, 'PeriodId');
        }
        if (year !== undefined && year !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>year, 'Year');
        }
        if (quarter !== undefined && quarter !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>quarter, 'Quarter');
        }
        if (organizationGroupIds) {
            organizationGroupIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrganizationGroupIds');
            })
        }
        if (criterionId !== undefined && criterionId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>criterionId, 'CriterionId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/analytic/report/criterion/file`;
        return this.httpClient.request<any>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAnalyticReportCriterionGet(requestParameters: ApiAnalyticReportCriterionGetRequestParams, observe?: 'body', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any>;
    public apiAnalyticReportCriterionGet(requestParameters: ApiAnalyticReportCriterionGetRequestParams, observe?: 'response', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpResponse<any>>;
    public apiAnalyticReportCriterionGet(requestParameters: ApiAnalyticReportCriterionGetRequestParams, observe?: 'events', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpEvent<any>>;
    public apiAnalyticReportCriterionGet(requestParameters: ApiAnalyticReportCriterionGetRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any> {
        const periodId = requestParameters.periodId;
        const year = requestParameters.year;
        const quarter = requestParameters.quarter;
        const organizationGroupIds = requestParameters.organizationGroupIds;
        const criterionId = requestParameters.criterionId;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (periodId !== undefined && periodId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>periodId, 'PeriodId');
        }
        if (year !== undefined && year !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>year, 'Year');
        }
        if (quarter !== undefined && quarter !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>quarter, 'Quarter');
        }
        if (organizationGroupIds) {
            organizationGroupIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrganizationGroupIds');
            })
        }
        if (criterionId !== undefined && criterionId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>criterionId, 'CriterionId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/analytic/report/criterion`;
        return this.httpClient.request<any>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAnalyticReportFileGet(requestParameters: ApiAnalyticReportFileGetRequestParams, observe?: 'body', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any>;
    public apiAnalyticReportFileGet(requestParameters: ApiAnalyticReportFileGetRequestParams, observe?: 'response', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpResponse<any>>;
    public apiAnalyticReportFileGet(requestParameters: ApiAnalyticReportFileGetRequestParams, observe?: 'events', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpEvent<any>>;
    public apiAnalyticReportFileGet(requestParameters: ApiAnalyticReportFileGetRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any> {
        const organizationId = requestParameters.organizationId;
        const periodId = requestParameters.periodId;
        const year = requestParameters.year;
        const quarter = requestParameters.quarter;
        const organizationGroupIds = requestParameters.organizationGroupIds;
        const criterionId = requestParameters.criterionId;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (organizationId !== undefined && organizationId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>organizationId, 'OrganizationId');
        }
        if (periodId !== undefined && periodId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>periodId, 'PeriodId');
        }
        if (year !== undefined && year !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>year, 'Year');
        }
        if (quarter !== undefined && quarter !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>quarter, 'Quarter');
        }
        if (organizationGroupIds) {
            organizationGroupIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrganizationGroupIds');
            })
        }
        if (criterionId !== undefined && criterionId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>criterionId, 'CriterionId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/analytic/report/file`;
        return this.httpClient.request<any>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAnalyticReportGeneralFileGet(requestParameters: ApiAnalyticReportGeneralFileGetRequestParams, observe?: 'body', reportProgress?: boolean, options?: {
        httpHeaderAccept?: string,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any>;
    public apiAnalyticReportGeneralFileGet(requestParameters: ApiAnalyticReportGeneralFileGetRequestParams, observe?: 'response', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpResponse<any>>;
    public apiAnalyticReportGeneralFileGet(requestParameters: ApiAnalyticReportGeneralFileGetRequestParams, observe?: 'events', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpEvent<any>>;
    public apiAnalyticReportGeneralFileGet(requestParameters: ApiAnalyticReportGeneralFileGetRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any> {
        const periodId = requestParameters.periodId;
        const year = requestParameters.year;
        const quarter = requestParameters.quarter;
        const organizationGroupIds = requestParameters.organizationGroupIds;
        const criterionId = requestParameters.criterionId;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (periodId !== undefined && periodId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>periodId, 'PeriodId');
        }
        if (year !== undefined && year !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>year, 'Year');
        }
        if (quarter !== undefined && quarter !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>quarter, 'Quarter');
        }
        if (organizationGroupIds) {
            organizationGroupIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrganizationGroupIds');
            })
        }
        if (criterionId !== undefined && criterionId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>criterionId, 'CriterionId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/analytic/report/general/file`;
        return this.httpClient.request<any>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    public apiAnalyticReportAllOrgsFileZipGet(requestParameters: ApiAnalyticReportFileGetRequestParams, observe?: 'body', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any>;
    public apiAnalyticReportAllOrgsFileZipGet(requestParameters: ApiAnalyticReportFileGetRequestParams, observe?: 'response', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpResponse<any>>;
    public apiAnalyticReportAllOrgsFileZipGet(requestParameters: ApiAnalyticReportFileGetRequestParams, observe?: 'events', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpEvent<any>>;
    public apiAnalyticReportAllOrgsFileZipGet(requestParameters: ApiAnalyticReportFileGetRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any> {
        const organizationId = requestParameters.organizationId;
        const periodId = requestParameters.periodId;
        const year = requestParameters.year;
        const quarter = requestParameters.quarter;
        const organizationGroupIds = requestParameters.organizationGroupIds;
        const criterionId = requestParameters.criterionId;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (organizationId !== undefined && organizationId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>organizationId, 'OrganizationId');
        }
        if (periodId !== undefined && periodId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>periodId, 'PeriodId');
        }
        if (year !== undefined && year !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>year, 'Year');
        }
        if (quarter !== undefined && quarter !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>quarter, 'Quarter');
        }
        if (organizationGroupIds) {
            organizationGroupIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrganizationGroupIds');
            })
        }
        if (criterionId !== undefined && criterionId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>criterionId, 'CriterionId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/analytic/report/allorgs/files/zip`;
        return this.httpClient.request<any>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }



    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAnalyticReportGeneralGet(requestParameters: ApiAnalyticReportGeneralGetRequestParams, observe?: 'body', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any>;
    public apiAnalyticReportGeneralGet(requestParameters: ApiAnalyticReportGeneralGetRequestParams, observe?: 'response', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpResponse<any>>;
    public apiAnalyticReportGeneralGet(requestParameters: ApiAnalyticReportGeneralGetRequestParams, observe?: 'events', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpEvent<any>>;
    public apiAnalyticReportGeneralGet(requestParameters: ApiAnalyticReportGeneralGetRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any> {
        const periodId = requestParameters.periodId;
        const year = requestParameters.year;
        const quarter = requestParameters.quarter;
        const organizationGroupIds = requestParameters.organizationGroupIds;
        const criterionId = requestParameters.criterionId;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (periodId !== undefined && periodId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>periodId, 'PeriodId');
        }
        if (year !== undefined && year !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>year, 'Year');
        }
        if (quarter !== undefined && quarter !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>quarter, 'Quarter');
        }
        if (organizationGroupIds) {
            organizationGroupIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrganizationGroupIds');
            })
        }
        if (criterionId !== undefined && criterionId !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>criterionId, 'CriterionId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/analytic/report/general`;
        return this.httpClient.request<any>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
 * @param requestParameters
 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
 * @param reportProgress flag to report request and response progress.
 */
    public apiAnalyticReportOrganizationsGet(
        requestParameters: ApiAnalyticReportOrganizationsGetRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: undefined,
            context?: HttpContext,
            transferCache?: boolean
        }
    ): Observable<any>;

    public apiAnalyticReportOrganizationsGet(
        requestParameters: ApiAnalyticReportOrganizationsGetRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: undefined,
            context?: HttpContext,
            transferCache?: boolean
        }
    ): Observable<HttpResponse<any>>;

    public apiAnalyticReportOrganizationsGet(
        requestParameters: ApiAnalyticReportOrganizationsGetRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: undefined,
            context?: HttpContext,
            transferCache?: boolean
        }
    ): Observable<HttpEvent<any>>;

    public apiAnalyticReportOrganizationsGet(
        requestParameters: ApiAnalyticReportOrganizationsGetRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: {
            httpHeaderAccept?: undefined,
            context?: HttpContext,
            transferCache?: boolean
        }
    ): Observable<any> {

        const periodId = requestParameters.periodId;
        const year = requestParameters.year;
        const quarter = requestParameters.quarter;
        const organizationGroupIds = requestParameters.organizationGroupIds;
        const criterionId = requestParameters.criterionId;

        let localVarQueryParameters = new HttpParams({
            encoder: this.encoder
        });

        if (periodId !== undefined && periodId !== null) {
            localVarQueryParameters = this.addToHttpParams(
                localVarQueryParameters,
                <any>periodId,
                'PeriodId'
            );
        }

        if (year !== undefined && year !== null) {
            localVarQueryParameters = this.addToHttpParams(
                localVarQueryParameters,
                <any>year,
                'Year'
            );
        }

        if (quarter !== undefined && quarter !== null) {
            localVarQueryParameters = this.addToHttpParams(
                localVarQueryParameters,
                <any>quarter,
                'Quarter'
            );
        }

        if (organizationGroupIds) {
            organizationGroupIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(
                    localVarQueryParameters,
                    <any>element,
                    'OrganizationGroupIds'
                );
            });
        }

        if (criterionId !== undefined && criterionId !== null) {
            localVarQueryParameters = this.addToHttpParams(
                localVarQueryParameters,
                <any>criterionId,
                'CriterionId'
            );
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected:
            string | undefined = options && options.httpHeaderAccept;

        if (localVarHttpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [];
            localVarHttpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }

        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set(
                'Accept',
                localVarHttpHeaderAcceptSelected
            );
        }

        let localVarHttpContext: HttpContext | undefined =
            options && options.context;

        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined =
            options && options.transferCache;

        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';

        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (
                this.configuration.isJsonMime(
                    localVarHttpHeaderAcceptSelected
                )
            ) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = `/api/analytic/report/organizations`;

        return this.httpClient.request<any>(
            'get',
            `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    public apiRatingAnalyticPeriods(requestParameters: ApiReportAnalyticPeriodsParams, observe?: 'body', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<{ values: Period[] }>;
    public apiRatingAnalyticPeriods(requestParameters: ApiReportAnalyticPeriodsParams, observe?: 'response', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpResponse<{ values: Period[] }>>;
    public apiRatingAnalyticPeriods(requestParameters: ApiReportAnalyticPeriodsParams, observe?: 'events', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpEvent<{ values: Period[] }>>;
    public apiRatingAnalyticPeriods(requestParameters: ApiReportAnalyticPeriodsParams, observe: any = 'body', reportProgress: boolean = false, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any> {
        const OrgStatusIds = requestParameters.OrgStatusIds;
        const OrganizationGroupIds = requestParameters.OrganizationGroupIds;
        const OrganizationIds = requestParameters.OrganizationIds;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (OrgStatusIds) {
            OrgStatusIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrgStatusIds');
            })
        }
        if (OrganizationGroupIds) {
            OrganizationGroupIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrganizationGroupIds');
            })
        }
        if (OrganizationIds) {
            OrganizationIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrganizationIds');
            })
        }


        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ratinganalytic/periods`;
        return this.httpClient.request<{ values: Period[] }>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    public apiRatingAnalyticRating(requestParameters: ApiReportAnalyticRatingParams, observe?: 'body', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any>;
    public apiRatingAnalyticRating(requestParameters: ApiReportAnalyticRatingParams, observe?: 'response', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpResponse<any>>;
    public apiRatingAnalyticRating(requestParameters: ApiReportAnalyticRatingParams, observe?: 'events', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpEvent<any>>;
    public apiRatingAnalyticRating(requestParameters: ApiReportAnalyticRatingParams, observe: any = 'body', reportProgress: boolean = false, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any> {
        const OrgStatusIds = requestParameters.OrgStatusIds;
        const OrganizationGroupIds = requestParameters.OrganizationGroupIds;
        const OrganizationIds = requestParameters.OrganizationIds;
        const Periods = requestParameters.Periods;
        const SearchString = requestParameters.SearchString;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (OrgStatusIds) {
            OrgStatusIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrgStatusIds');
            })
        }
        if (OrganizationGroupIds) {
            OrganizationGroupIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrganizationGroupIds');
            })
        }
        if (OrganizationIds) {
            OrganizationIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrganizationIds');
            })
        }
        if (Periods) {
            Periods.forEach((period, index) => {
                localVarQueryParameters = localVarQueryParameters.append(`Periods[${index}].Year`, period.year?.toString() ?? '0');
                if (period.quarter !== null) {
                    localVarQueryParameters = localVarQueryParameters.append(`Periods[${index}].Quarter`, period.quarter.toString());
                }
            });
        }
        if(SearchString) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                <any>SearchString, 'SearchString'
            );
        }


        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ratinganalytic/rating`;
        return this.httpClient.request<any>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    public apiRatingAnalyticRatingFileGet(requestParameters: ApiReportAnalyticRatingParams, observe?: 'body', reportProgress?: boolean, options?: {
        httpHeaderAccept?: string,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any>;
    public apiRatingAnalyticRatingFileGet(requestParameters: ApiReportAnalyticRatingParams, observe?: 'response', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpResponse<any>>;
    public apiRatingAnalyticRatingFileGet(requestParameters: ApiReportAnalyticRatingParams, observe?: 'events', reportProgress?: boolean, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<HttpEvent<any>>;
    public apiRatingAnalyticRatingFileGet(requestParameters: ApiReportAnalyticRatingParams, observe: any = 'body', reportProgress: boolean = false, options?: {
        httpHeaderAccept?: undefined,
        context?: HttpContext,
        transferCache?: boolean
    }): Observable<any> {
        const OrgStatusIds = requestParameters.OrgStatusIds;
        const OrganizationGroupIds = requestParameters.OrganizationGroupIds;
        const OrganizationIds = requestParameters.OrganizationIds;
        const Periods = requestParameters.Periods;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (OrgStatusIds) {
            OrgStatusIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrgStatusIds');
            })
        }
        if (OrganizationGroupIds) {
            OrganizationGroupIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrganizationGroupIds');
            })
        }
        if (OrganizationIds) {
            OrganizationIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                    <any>element, 'OrganizationIds');
            })
        }
        if (Periods) {
            Periods.forEach((period, index) => {
                localVarQueryParameters = localVarQueryParameters.append(`Periods[${index}].Year`, period.year?.toString() ?? '0');
                if (period.quarter !== null) {
                    localVarQueryParameters = localVarQueryParameters.append(`Periods[${index}].Quarter`, period.quarter.toString());
                }
            });
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ratinganalytic/rating/file`;
        return this.httpClient.request<any>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
